import { render } from "./DynamicTag.vue?vue&type=template&id=31c90533&ts=true"
import script from "./DynamicTag.vue?vue&type=script&lang=ts"
export * from "./DynamicTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31c90533"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31c90533', __exports__)) {
    api.reload('31c90533', __exports__)
  }
  
  module.hot.accept("./DynamicTag.vue?vue&type=template&id=31c90533&ts=true", () => {
    api.rerender('31c90533', render)
  })

}


export default __exports__